/* eslint-disable node/no-process-env */

export const algoliaAppId = process.env.NEXT_PUBLIC_ALGOLIA_APP_ID ?? "";

export const algoliaSearchKey =
  process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_KEY ?? "";

export const algoliaIndexName =
  process.env.NEXT_PUBLIC_ALGOLIA_INDEX_NAME ?? "";
